import React from "react";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
const Header = () => {
  return (
    <>
      <Navbar bg="dark sticky-top" expand="lg">
        <Container>
          <Navbar>
            <Link to="./Homzy-Real-Estate">
              <img src={require("../../imgs/logo.png")} alt="" />
            </Link>
          </Navbar>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="togglerBtn"
          />
          <Navbar.Collapse id="basic-navbar-nav" className="text-light">
            <Nav className="ms-auto navbar-nav text-capitalize">
              <Link to="./Homzy-Real-Estate" className="p-3 fs-6 text-light">
                Home
              </Link>

              <Link
                to="./Homzy-Real-Estate/Residences"
                className="p-3 fs-6 text-light"
              >
                residencies
              </Link>

              <Link
                to="./Homzy-Real-Estate/Value"
                className="p-3 fs-6 text-light"
              >
                our value
              </Link>

              <Link
                to="./Homzy-Real-Estate/Contact"
                className="p-3 fs-6 text-light"
              >
                concat us
              </Link>

              <Link
                to="./Homzy-Real-Estate/started"
                className="p-3 fs-6 text-light"
              >
                get started
              </Link>
            </Nav>
            <a
              className="btn btn-primary text-capitalize"
              href="mailto:hossamahmed8862@gmail.com"
            >
              contact
            </a>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
